<template>
  <div class="home">

    <div class="file_list">
      <div 
        v-for="(item, index) in List" 
        :key="index" 
        class="file_list_item" 
        :class="{'type-3 ': (index + 1) % 3 === 0}"
        @click="toNext(item)"
        >
        <img src="../../assets/alicon/folder.png" alt="" class="file_list_item_img" />
        <img v-if="item.type === 1" src="../../assets/alicon/imgicon.png" alt="" class="img_icon" />
        <img v-if="item.type === 2" src="../../assets/alicon/videoicon.png" alt="" class="img_icon" />
        <img v-if="item.type === 3 || item.type === 4 || item.type === 5" src="../../assets/alicon/audioicon.png" alt="" class="img_icon" />
        <div class="file_list_item_name"> {{ item.name }}</div>
      </div>
    </div>


    <!-- <div class="home_btn">
      <van-button 
        :loading="isLoading"
        type="info" 
        size="middle" 
        @click="Synchronous" 
        class="btn_sync"
        loading-text="加载中..."
      >
        素材同步
      </van-button>
    </div> -->
  </div>
</template>

<script>
import { 
  getToken, 
  setUserName, 
  getUserName 
} from '../../utils/auth'
import store from '@/store'
import { Toast } from 'vant-green';
export default {
  name: 'home',
  components: {

  },
  data() {
    return {
      pageType:1,
      // 1 图片 2 视频 3 音频 4 ai配音 5用户上传的配音
      List: [
        { 
          name: '图片',
          type:1,
        },
        { name: '视频',
          type:2,
        },
        { name: '音频',
          type:3,
        },
        { name: 'ai配音',
          type:4,
        },
        { name: '用户上传的配音',
          type:5,
        }
      ],
      isLoading: false,
      token:''
    };
  },
  computed:{

  },

  created() {
    document.title = '素材库';
    this.init()
  },

  methods:{
    // 初始化
    init(){
      // if(getUserName()&&getUserName().length>1){
      //   // 
      //   store.dispatch('user/login', { username:getUserName()}).then((res) => {
      //     // console.log(res.data)
      //     // http://file-front.zwstk.cn?username=zmxagent
      //   })
      // } else {
      //   const urlParams = new URLSearchParams(window.location.search) 
      //   const username = urlParams.get('username')
      //   if(username){
      //     setUserName(username)
      //     store.dispatch('user/login', { username:username}).then((res) => {
      //       // console.log(res.data)
      //       // http://file-front.zwstk.cn?username=zmxagent
      //     })
      //   } else {
      //     this.$router.push({
      //       path: '/408',
      //       replace: true
      //     })
      //   }
      // }
      const urlParams = new URLSearchParams(window.location.search) 
      const username = urlParams.get('username')
      if(username){
        setUserName(username)
        store.dispatch('user/login', { username:username}).then((res) => {
          // console.log(res.data)
          // http://file-front.zwstk.cn?username=zmxagent
        })
      } else if(getUserName()&&getUserName().length>1){
        store.dispatch('user/login', { username:getUserName()}).then((res) => {
          // console.log(res.data)
          // http://file-front.zwstk.cn?username=zmxagent
        })
      } else {
        this.$router.push({
          path: '/408',
          replace: true
        })
      }
    },

    // 素材同步
    Synchronous(){
      if(this.isLoading === false){
        this.isLoading = true
        setTimeout(() => {
          this.isLoading = false
        }, 3000);
      } else {
        Toast('请不要重复点击！');
      }
      // MaterialSynchronization({ }).then((res) => {
      //   this.gstFileList()
      // })
    },

    // 前往下一级
    toNext(item){
      this.$router.push({
        path: '/expand?type='+item.type,
        replace: true
      })
    }

    
  }
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  position: relative;
  .file_list{
    position: relative;
    top: 50px;
    // padding-left: 20px; 
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    // justify-content: space-around;
    .file_list_item{
      position: relative;
      margin-bottom: 20px;
      width: 33%;
      // width: 102px;
      // margin-right: 25px;
      // border:1px solid #ccc;
      text-align: center;
      .file_list_item_img{
        // width: 90px;
        // height: 70px;
        width: 80%;
        height: auto;
      }
      .img_icon{
        position: absolute;
        // top: 20px;
        // left: 30px;
        width: 56px;
        height: 56px;
        left: 0;
        right: 0;
        margin: auto;
        top: 30px;
      }
      .file_list_item_name{
        // text-align: left;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 90%; // 根据需要调整最大宽度
      }
    }
    .type-3 {
      margin-right: 0px;
    }
  }

  .home_btn{
    position: fixed;
    left: 0;
    bottom: 100px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .btn_sync{
      width: 180px;
    }
  }
}
</style>